import {addEvent} from '../add-event'
import {getAttachmentType} from '../helpers/attachment-type-helper'

export function viewAttachmentEvent(
    contentType: string,
    pageOfReport: number,
    reportType: string,
): boolean {
    return addEvent('reportsPageViewAttachment', {
        typeOfAttachment: getAttachmentType(contentType),
        pageOfReport,
        reportType,
    })
}
